import _ from 'lodash'
import {cdn} from '@/commons/js/Utils'

export default {
  computed: {
    about() { return this.$store.getters['app/about'] },
    orientation() { return this.$store.getters['app/orientation'] },
    isPlaying() { return this.$store.getters['app/isPlaying'] },
    conclusion() { return this.$store.getters['app/conclusion'] },
    vr() { return this.$store.getters['app/vr'] },
    fullscreen() { return this.$store.getters['app/fullscreen'] },
    levels() { return this.$store.getters['app/levels'] },
    captations() { return this.$store.getters['app/captations'] },
  },
  watch: {
    orientation() { this.setDyniquePos() },
    vr() { this.setDyniquePos() }
  },
  methods: {
    setDyniquePos(ref) {
      if(this.checkPos) {
        if(ref)
          return this.setDyniquePosEach(_.find(this.checkPos, c => c.ref == ref))

        _.each(this.checkPos, p => {
          if(!p || !this.$refs[p.ref]) return
          this.setDyniquePosEach(p)
        })
      }
    },
    setDyniquePosEach(p) {
      if(p.desktop)
        TweenLite.set(this.$refs[p.ref], { aframe: { ...p.desktop } })

      if(this.vr)
        return TweenLite.set(this.$refs[p.ref], { aframe: { ...p.desktop } })

      if(this.$root.$agent.mobile && p.mobile)
        TweenLite.set(this.$refs[p.ref], { aframe: { ...p.mobile } })

      if(this.orientation == 'landscape' && this.$root.$agent.mobile && p.landscape)
        TweenLite.set(this.$refs[p.ref], { aframe: { ...p.landscape } })

      if(this.vr && p.vr)
        TweenLite.set(this.$refs[p.ref], { aframe: { ...p.vr } })
    },
    cdn(url) {
      return cdn(url)
    },
    next() {
      const routeName = this.$route.meta.name
      const level = this.$route.params.level
      const captation = this.$route.params.captation

      if(routeName == 'start')
        return this.$router.push({ name: 'captation.' + this.lang, params: { level: 'intro-3', captation: 'intro-3' } })

      if(routeName == 'level')
        return this.$router.push({ name: 'captation.' + this.lang, params: { level: level } })

      if(routeName == 'conclusion') {
        this.$store.commit('app/CONCLUSION')
        return this.$router.push({ name: 'explorer.' + this.lang })
      }

      if(routeName == 'captation' && captation) {
        if(this.conclusion)
          return this.$router.push({ name: 'explorer.' + this.lang })

        if(captation == 'intro-3')
          return this.$router.push({ name: 'level.' + this.lang, params: { level: 1 } })

        if(level === '7')
          return this.$router.push({ name: 'conclusion.' + this.lang })

        return this.$router.push({ name: 'level.' + this.lang, params: { level: parseInt(level) + 1 } })
      }
    },
    detach( child, parent, scene ) {
      child.applyMatrix( parent.matrixWorld )
      parent.remove( child )
      scene.add( child )
    },
    attach( child, scene, parent ) {
      child.applyMatrix( new THREE.Matrix4().getInverse( parent.matrixWorld ) )
      scene.remove( child )
      parent.add( child )
    },
    inlineObject(object) {
      let inline = ''
      _.each(object, (o,k) => inline += k + ':' + o + ';')
      return inline
    },
    inlinePosition(object) {
      return _.map(object, (o,k) => o).join(' ')
    },
    // toScreenPosition(el) {
    //   const vector = new THREE.Vector3()
    //   const camera = el.sceneEl.camera
    //   const obj = el.object3D
    //   const widthHalf = 0.5 * window.innerWidth
    //   const heightHalf = 0.5 * window.innerHeight

    //   obj.updateMatrixWorld()
    //   vector.setFromMatrixPosition(obj.matrixWorld)
    //   vector.project(camera)

    //   vector.x = ( vector.x * widthHalf ) + widthHalf
    //   vector.y = - ( vector.y * heightHalf ) + heightHalf

    //   return {
    //     x: vector.x,
    //     y: vector.y
    //   }
    // },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Aframe.js